var _style, _g, _g2, _polyline, _polyline2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 787.9 160",
    style: {
      enableBackground: "new 0 0 787.9 160"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M367.6,35.7h8.9l10.5,20v-20h8.8v36.1H387l-10.6-20.2v20.1h-8.8V35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.8,35.8h20.6v8.3h-11.8v6.2h10.8v6.6h-10.8v6.6h11.8v8.4h-20.6V35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.1,35.7h9.3l6.5,22.4l6.6-22.4h7.4l6.7,22.4l6.5-22.4h9.2l-10.7,36h-8.9l-6.4-21.8L452,71.7h-9L432.1,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.6,88.3h20.6v8.3h-11.8v6.2h10.8v6.6h-10.8v6.6h11.8v8.4h-20.6V88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.2,88.3h8.9l10.5,20v-20h8.8v36.1h-8.8l-10.5-20.2v20.1h-8.8v-36H397.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.3,96.6h-7.2v-8.4h23.3v8.4h-7.3v27.8h-8.8V96.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,88.3h20.6v8.3h-11.8v6.2h10.8v6.6h-10.8v6.6h11.8v8.4H464V88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.6,124.3l-3-7.3c-0.8,0.1-1.8,0.2-2.7,0.2h-1.5v7.2h-8.8V88.3h9c11.9,0,16.3,7,16.3,14.5c0,4.2-1.4,8.3-4.6,11 l5.5,10.6L509.6,124.3L509.6,124.3z M504.2,108.6c4.1,0,6.2-2.5,6.2-5.9s-2.1-5.9-6.2-5.9h-1.8v11.8H504.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.6,96.6h-7.2v-8.4h23.3v8.4h-7.3v27.8h-8.8V96.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.5,119.9h-13.9l-1.5,4.5h-9.2l13.1-36h9.1l12.9,36h-9L573.5,119.9z M571.3,113l-4.7-14.2l-4.7,14.2 C561.9,113,571.3,113,571.3,113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.8,88.3h8.8v36h-8.8V88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.4,88.3h8.9l10.5,20v-20h8.8v36.1h-8.8l-10.6-20.1v20.1h-8.8V88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.6,88.3h11.7l9.2,24.5l9.1-24.5h11.6v36h-8.8v-21.1l-8,21.1h-7.8l-8.1-21.4v21.4h-8.9V88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.2,88.3h20.6v8.3H708v6.2h10.8v6.6H708v6.6h11.8v8.4h-20.6V88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.8,88.3h8.9l10.5,20v-20h8.8v36.1h-8.8l-10.6-20.2v20.1h-8.8V88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M771.9,96.6h-7.3v-8.4h23.3v8.4h-7.3v27.8h-8.8L771.9,96.6L771.9,96.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0v159.9h159.9V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M169.8,0v160h159.7V0H169.8z"
  }))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "101.2,9.2 101.2,106.8 110.8,106.8 110.8,9.2 150.8,9.2 150.8,150.7 59.5,150.7 59.5,58.1 49.9,58.1  49.9,150.7 9.6,150.7 9.6,9.2 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "320.3,9.3 320.3,54.7 224.7,54.7 224.7,64.4 320.3,64.4 320.3,100.6 224.7,100.6 224.7,110.3  320.3,110.3 320.3,150.6 179,150.6 179,9.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNgLogo);
export default __webpack_public_path__ + "static/media/ng-logo.89480476262aebe0ae0872b50c105c45.svg";
export { ForwardRef as ReactComponent };